<template>
	<div class="ModBalanceWrap ">
		<span class="valueTd__svg icon_dollars">$</span>
		<div :class="['valueTd__text', getStatus()]">{{ getCurrency(line[item.value]) }}</div>
	</div>
</template>

<script>
import { formatCurrency } from "@/helper";

export default {
	name: "ModBalanceTow",
	props: {
		item: Object,
		line: Object
	},
	methods: {
		getStatus() {
			if (this.line[this.item.value] === 0 ) return '';
			return this.line[this.item.value] > 0 ? 'text-green' : 'text-red';
		},
		getCurrency(total) {
			if (Object.is(total, -0)) return formatCurrency(0);
			return formatCurrency(total);
		},
	}
};
</script>

<style scoped lang="scss">
.ModBalanceWrap {
	width: 100%;
	min-width: 96px;
	display: flex;
	align-items: center;
	gap: 3px;
	flex-grow: 2;
	.text-red {
		color: rgba(228, 3, 42, 0.7);
	}
	.text-green {
		color: #3ad558;
	}

	.valueTd__svg {
		color: #8F90A6;

		svg {
			display: block;
		}
	}
}
</style>
